
import { Box, colors, Container, Divider, Grid, Typography } from "@mui/material";
import QueryForm from "../component/QueryForm";
import { Link, useLocation } from "react-router-dom";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/Blue.png'
import './index.css'
const Footer = () => {
    const location = useLocation(); // Get the current path
    const handleClick = () => {
        window.scrollTo(0, 0); // Scroll to top
    };
    const services = [
        {
            "service": "Artificial Intelligence",
            "url": "/offering/artificialintelligence"
        },
        {
            "service": "Custom Software Development",
            "url": "/offering/CustomerSoftDev"
        },
        {
            "service": "RPA",
            "url": "/offering/rpa"
        },
        {
            "service": "Security",
            "url": "/offering/security"
        },
        
        {
            "service": "Business Process Services",
            "url": "/offering/businessprocessservices"
        },
        
        {
            "service": "Consultancy",
            "url": "/offering/consultancy"
        },
    
    ];
    return (
        <>
            <Container Container maxWidth={false} style={{ paddingLeft: '50px', paddingRight: '50px', backgroundColor: "black", marginTop: "10px", borderTopLeftRadius: "45px", borderTopRightRadius: "45px", color: "white" }}>
                <Grid container style={{ paddingTop: "20px", textAlign: "left" }} spacing={10}>
                    <Grid item xs={12} sm={4} md={4} sx={{ textAlign: 'center' }}> {/* Added textAlign for center alignment */}
                        <Box
                            component="img"
                            sx={{
                                width: "50%", // Adjust the width as needed 
                                display: 'block', // Ensures the image takes up space properly
                                margin: '0 auto', // Centers the image horizontally
                            }}
                            src={logo}
                            alt="Edgology Logo"
                        />

                        <Typography
                            component="p"
                            className="poppins-regular"
                            sx={{
                                color: "white",
                                marginTop: '20px', // Adds some spacing between the image and the text
                                fontSize: {

                                    xl: "1.1rem",
                                    lg: "0.8rem",
                                    md: "0.7rem",
                                    sm: "0.6rem",
                                    xs: "0.8rem"
                                }, // Adjust the font size if needed
                                textAlign: 'left', // Align the text to the left
                            }}
                        >
                            We specialize in innovative educational technology that transforms how people learn and teach. Our mission is to provide intuitive, high-quality software solutions that empower educators and learners in the digital age. Committed to driving educational success, we offer user-friendly tools that meet the needs of today’s fast-paced world.
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sm={3} md={3}>
                        <Typography variant="h5" className="poppins-semibold" sx={{
                            marginBottom: "20px", fontSize: {
                                xl: "1.5rem",
                                lg: "1.1rem",
                                md: "0.8rem",
                                sm: "0.8rem",
                                xs: "0.8rem"
                            }
                        }}> {/* Add margin to the bottom for spacing */}
                            KEEP CONNECTED WITH US
                        </Typography>

                        {/* LinkedIn */}
                        <Typography component="div" sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}> {/* Aligns items in the center and adds bottom space */}
                            <FontAwesomeIcon icon={faLinkedin} style={{ marginRight: "10px" }} /> {/* Adjust icon size if needed */}
                            <Typography variant="h6" className="poppins-regular" sx={{fontSize: {
                                        xl: "1.2rem",
                                        lg: "1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }}}>Make Connection </Typography>
                        </Typography>

                        {/* Twitter */}
                        <Typography component="div" sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <FontAwesomeIcon icon={faTwitter} style={{ marginRight: "10px" }} />
                            <Typography variant="h6" className="poppins-regular" sx={{fontSize: {
                                        xl: "1.2rem",
                                        lg: "1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }}}>Follow us </Typography>
                        </Typography>

                        {/* WhatsApp */}
                        <Typography component="div" sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: "10px" }} />
                            <Typography variant="h6" className="poppins-regular" sx={{fontSize: {
                                        xl: "1.2rem",
                                        lg: "1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }}}>Chat with us </Typography>
                        </Typography>
                        <Typography component='div' style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "10px" }} />
                            <Typography variant="h6" className="poppins-regular" sx={{fontSize: {
                                        xl: "1.2rem",
                                        lg: "1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }}}>Mail</Typography>
                        </Typography>
                    </Grid>

                    <Grid item xs={4} sm={3}   md={3}>
                        <Box sx={{ display: "block" }}>
                            <Typography variant="h5" className="poppins-semibold" sx={{
                                color: "white", marginBottom: "20px", fontSize: {
                                    xl: "1.5rem",
                                    lg: "1.2rem",
                                    md: "0.8rem",
                                    sm: "0.8rem",
                                    xs: "1rem"
                                },
                            }}>
                                Services
                            </Typography>
                            {services.map((item, index) => (
                                // <Grid item xs={12} sm={6} key={index}>
                                <Link to={item.url} style={{textDecoration:"none"}}>
                                <Typography
                                    variant="body1"
                                    sx={{ color: "white", marginBottom: "10px",fontSize: {
                                        xl: "1.2rem",
                                        lg: "1.1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    } }}
                                    className="poppins-regular"
                                >
                                    {item.service}
                                </Typography>
                                </Link>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={4} sm={2}   md={2}>
                        <Box sx={{ display: "block" }}>
                            <Typography variant="h5" className="poppins-semibold" sx={{
                                color: "white", marginBottom: "20px", fontSize: {
                                    xl: "1.5rem",
                                    lg: "1.2rem",
                                    md: "0.8rem",
                                    sm: "0.8rem",
                                    xs: "1rem"
                                }
                            }}>
                                Company
                            </Typography>
                            <Link to='/about' style={{textDecoration:"none"}}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "white", marginBottom: "10px", fontSize: {
                                        xl: "1.2rem",
                                        lg: "1rem",
                                        md: "0.7rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }
                                }}
                                className="poppins-regular"
                            >
                                About Us
                            </Typography>
                            </Link>
                            {/* <Typography
                                variant="body1"
                                sx={{ color: "white", marginBottom: "10px",fontSize: {
                                    xl: "1.2rem",
                                    lg: "1rem",
                                    md: "0.7rem",
                                    sm: "0.7rem",
                                    xs: "0.7rem"
                                } }}
                                className="poppins-regular"
                            >
                                Privacy Notice
                            </Typography> */}
                            <Link to='/termsandcondition' style={{textDecoration:"none"}}>
                            <Typography
                                variant="body1"
                                sx={{ color: "white", marginBottom: "10px",fontSize: {
                                    xl: "1.2rem",
                                    lg: "1rem",
                                    md: "0.7rem",
                                    sm: "0.7rem",
                                    xs: "0.7rem"
                                } }}
                                className="poppins-regular"
                            >
                                Terms and Conditions
                            </Typography>
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} >
                        <Box
                            sx={{
                                textAlign: "right", // Aligns content to the right
                                // Adds padding to the content
                                color: "white" // Sets text color to white
                            }}
                        >© 2024 Edgology Technologies Pvt. Ltd. All rights reserved.</Box>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
};

export default Footer;
